import { get, set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import SEARCH_CONTEXT from '../../../../../constants/reservation/SearchContext';
import {
  onChangeQuery,
  onClearQuery
} from '../../../actions/components/search';

const defaultQuery = { q: '' };

const initialState = {
  byContext: {
    [SEARCH_CONTEXT.TODAY]: { ...defaultQuery },
    [SEARCH_CONTEXT.UPCOMING]: { ...defaultQuery },
    [SEARCH_CONTEXT.PENDING]: { ...defaultQuery },
    [SEARCH_CONTEXT.ARCHIVED]: { ...defaultQuery }
  }
};

const onChangeQueryHandler = action => ({
  [action.toString()]: (state, { payload: { context, query } }) =>
    set(`byContext.${context}`, query, state)
});

const onClearQueryHandler = action => ({
  [action.toString()]: (state, { payload: { context } }) =>
    set(
      `byContext.${context}`,
      get(`byContext.${context}`, initialState),
      state
    )
});

export default createReducer(initialState, {
  ...onChangeQueryHandler(onChangeQuery),
  ...onClearQueryHandler(onClearQuery)
});
